/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
const visibilityMap = {
	// document property: event name
	hidden: 'visibilitychange',
	mozHidden: 'mozvisibilitychange',
	msHidden: 'msvisibilitychange',
	webkitHidden: 'webkitvisibilitychange',
} as const;

const supportedHiddenKey = Object.keys(visibilityMap).find(
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
	(key) => typeof document !== 'undefined' && typeof document[key] !== 'undefined',
);

// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const supportedVisiblityEvent: any = visibilityMap[supportedHiddenKey];

export const isPageVisible = (): boolean =>
	// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
	typeof document !== 'undefined' && !document[supportedHiddenKey];
